class InfiniteBanner {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-infinite-banner-track]');
    this.contents = section.querySelectorAll('[data-infinite-banner-content]');
    
    if (!this.track || this.contents.length === 0) return;
    
    this.init();
  }

  init() {
    this.duplicateContent();
    this.setupHoverPause();
    this.setupAccessibility();
  }

  duplicateContent() {
    this.contents.forEach(content => {
      const items = Array.from(content.children);
      const itemCount = items.length;
      
      if (itemCount === 0) return;

      const contentWidth = content.scrollWidth;
      const trackWidth = this.track.offsetWidth;
      
      const duplicatesNeeded = Math.max(1, Math.ceil(trackWidth / contentWidth));
      
      const fragment = document.createDocumentFragment();
      
      for (let i = 0; i < duplicatesNeeded; i++) {
        items.forEach(item => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          fragment.appendChild(clone);
        });
      }
      
      content.appendChild(fragment);
    });
  }

  setupHoverPause() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    if (prefersReducedMotion) return;

    this.section.addEventListener('mouseenter', () => {
      this.contents.forEach(content => {
        content.classList.add('infinite-banner__content--paused');
      });
    });

    this.section.addEventListener('mouseleave', () => {
      this.contents.forEach(content => {
        content.classList.remove('infinite-banner__content--paused');
      });
    });

    this.section.addEventListener('focusin', () => {
      this.contents.forEach(content => {
        content.classList.add('infinite-banner__content--paused');
      });
    });

    this.section.addEventListener('focusout', () => {
      this.contents.forEach(content => {
        content.classList.remove('infinite-banner__content--paused');
      });
    });
  }

  setupAccessibility() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    if (prefersReducedMotion) {
      this.contents.forEach(content => {
        content.style.animation = 'none';
      });
    }

    window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', (e) => {
      if (e.matches) {
        this.contents.forEach(content => {
          content.style.animation = 'none';
          content.classList.remove('infinite-banner__content--paused');
        });
      } else {
        this.contents.forEach(content => {
          content.style.animation = '';
        });
      }
    });
  }
}

function initInfiniteBanners() {
  const sections = document.querySelectorAll('.infinite-banner');
  sections.forEach(section => {
    new InfiniteBanner(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initInfiniteBanners);
} else {
  initInfiniteBanners();
}

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.infinite-banner');
    if (section) {
      new InfiniteBanner(section);
    }
  });
}
